define([
	"dojo/_base/declare",
	"csi/session",
	"csi/view/ToolbarPlugin",
	"csi/widget/FilteringSelect"
], function(declare, session, ToolbarPlugin, FilteringSelect) {

	return declare([FilteringSelect, ToolbarPlugin], {
		// override ComboBox member
		required: false,

		// SearchChild: child search parameters
		defSearch: null,


		postMixInProperties: function() {
			// summary: resolve search action for tooltip
			this.defAction.resolve();
			this.title = this.defAction.getDescription();
			this.inherited(arguments);
		},

		postCreate: function() {
			// summary: connect to onFocus event to invoke search
			this.inherited(arguments);
			this.textbox.value = this.defSearch.name;
		},

		getSearchBox: function() {
			// summary: in this case, the crumb is already a combo box
			return this;
		},

		onChange: function(/*Objct*/value, /*Action*/action) {
			// summary: set new location
			session.setLocationUrl(value);
		},

		onBlur: function() {
			// summary: start child search
			this.textbox.value = this.defSearch.name;
		},

		onFocus: function() {
			// summary: start child search
			this.textbox.value = "";
		},

		isValid: function() {
			if (!this.defSearch || (this.textbox.value == this.defSearch.name)) return true;
			return this.inherited(arguments);
		}
	});
});